// Persistent per-browser device id used for abuse fingerprinting.
// Server combines this with IP; wiping localStorage does NOT unlock unlimited free scans
// because the IP half still matches. Two layers = decent friction.
export function getDeviceId() {
  let id = localStorage.getItem("cf_device_id");
  if (!id) {
    id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("cf_device_id", id);
  }
  return id;
}
